import { configureStore } from '@reduxjs/toolkit';
import { historyMiddleware } from './Middlewares/History.middleware';
import { gtmMiddleware } from './Middlewares/Gtm.middleware';
import reducers from './reducers';

export const createStore = (preloadState) =>
  configureStore({
    preloadedState: preloadState,
    reducer: reducers,
    middleware: [historyMiddleware, gtmMiddleware],
  });

const store = createStore(global['LitiumPreloadState']);
export type AppDispatch = typeof store.dispatch;
export default store;
